import * as z from "zod/v4";
import { MarketingAgentAnalyticsInputSchema } from "./common";

const ChannelDistributionItemSchema = z.object({
  channel: z.string(),
  count: z.number(),
});

export const getMarketingAgentChannelDistribution = {
  name: "getMarketingAgentChannelDistribution" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.array(ChannelDistributionItemSchema),
};
